import classNames from 'classnames'
import type { FunctionalComponent } from 'preact'
import styles from './index.module.scss'

export const Chip:
  & FunctionalComponent<{
    type?: 'icon'
    active?: boolean
    onClick?: () => void
  }>
  & {
    List: FunctionalComponent
  } = props => {
    return (
      <button
        onClick={props.onClick}
        class={classNames(styles.root, {
          [styles.active]: props.active,
          [styles.icon]: props.type === 'icon',
        })}
      >
        {props.children}
      </button>
    )
  }

Chip.List = props => <div class={styles.list}>{props.children}</div>
